import { useLocation, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

const NotFound = () => {
  const location = useLocation();
  const [redirectTo, setRedirectTo] = useState<string | null>(null);
  const [checked, setChecked] = useState(false);

  const isLegacyJobSite = location.pathname.startsWith("/job-site-cameras-");

  // Renamed blog post slugs (e.g. -in-2025-* → -in-2026-*)
  useEffect(() => {
    if (isLegacyJobSite) return;
    const blogMatch = location.pathname.match(/^\/blog\/([^/]+)\/?$/);
    if (!blogMatch) {
      setChecked(true);
      return;
    }
    const oldSlug = blogMatch[1];
    let cancelled = false;
    (async () => {
      const { data } = await supabase
        .from("blog_post_redirects" as never)
        .select("new_slug")
        .eq("old_slug", oldSlug)
        .maybeSingle();
      if (cancelled) return;
      const newSlug = (data as { new_slug?: string } | null)?.new_slug;
      if (newSlug) {
        setRedirectTo(`/blog/${newSlug}`);
      }
      setChecked(true);
    })();
    return () => { cancelled = true; };
  }, [location.pathname, isLegacyJobSite]);

  useEffect(() => {
    if (!isLegacyJobSite && checked && !redirectTo) {
      console.error("404 Error: User attempted to access non-existent route:", location.pathname);
    }
  }, [checked, redirectTo, location.pathname, isLegacyJobSite]);

  // Legacy /job-site-cameras-* → /locations
  if (isLegacyJobSite) {
    return <Navigate to="/locations" replace />;
  }

  if (redirectTo) {
    return <Navigate to={redirectTo} replace />;
  }

  if (!checked) {
    return <div style={{ minHeight: "100vh" }} />;
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted">
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold">404</h1>
        <p className="mb-4 text-xl text-muted-foreground">Oops! Page not found</p>
        <a href="/" className="text-primary underline hover:text-primary/90">
          Return to Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
